import { createContext } from 'react';

const ApplicationContext = createContext({
  currentApplication: null,
  setCurrentApplication: () => {},
  applications: []
});

export default ApplicationContext;